<template>
    <div class="action">
        <el-popover
            placement="bottom"
            width="200"
            v-model="showFacesheetPopover"
            popper-class="facesheet-popover"
            :class="['popover-wrapper', { 'popover-full': !getCurrentProvider }]"
            trigger="click">
            <!-- @click="printFacesheet" -->
            <div class="print-facesheet">
                <!-- Emit event to print all selected Patients-->
                <div class="print" @click="printFacesheet" style="display: none;">
                    Print All ({{ allPrintPatients.length }})
                </div>
                <div
                    class="print"
                    @click="printActiveFacesheet"
                    v-if="activeSelectedPatients.length > 0"
                >
                    Print Active ({{ activeSelectedPatients.length }})
                </div>
                <div class="print print-inactive" v-else>
                    No Active Patients
                </div>
                <div class="print-cancel" @click="showFacesheetPopover = false">
                    Cancel
                </div>
            </div>
            <el-button
                slot="reference"
                type="primary"
                :disabled="!isSelectedPatient"
                :class="{ full: !getCurrentProvider }">
                Print Face Sheet
            </el-button>
        </el-popover>
        <el-button
          v-if="getCurrentProvider"
          class="dark-button"
          :disabled="!isSelectedPatient"
          @click="newMessageDialog = true"
        >
          Send Message
        </el-button>
        <MessageDialog
            :patient-list="selectedPatientList"
            :show-message="newMessageDialog"
            @remove-patient="removePatient"
            @close="newMessageDialog = false"
            />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MessageDialog from "@/module/engagement/common/MessageDialog"


export default {
    name: 'print-facesheet',

    props: {
        allPrintPatients: {
            type: Array,
            default: () => [],
        },
        selectedPatientList: {
            type: Array,
            default: () => [],
        },
        isSelectedPatient: {
            type: Boolean,
            default: false,
        },
        getCurrentProvider: {
            type: String,
        },
    },

    data() {
        return {
            showFacesheetPopover: false,
            newMessageDialog: false,
        }
    },

    methods : {
        /**
         * Print All Patient Face Sheet
         */
        printFacesheet() {
            // this.$emit('print', this.select)
            const provider = this.getCurrentProvider
                ? this.getCurrentProvider
                : this.getProvidersIdArray.join(",")
            window.open(
                this.baseUrl +
                "/document/facesheet/?id=" +
                this.allPrintPatients.map(({ id }) => id).join(",") +
                "&provider=" +
                provider
            )
        },
        /**
         * Print Active Patient Face Sheet
         */
        printActiveFacesheet() {
            const provider = this.getCurrentProvider
                ? this.getCurrentProvider
                : this.getProvidersIdArray[0]
            window.open(
                this.baseUrl +
                `/provider/${provider}/print?document_type=facesheet&ids=` + 
                this.activeSelectedPatients.map(({ next_schedule_id }) => next_schedule_id).join(",")
            )
            this.showFacesheetPopover = false
        },
        /**
         * Remove Patient from Message Dialog
         * by emitting event to parent component
         * that deselects the patient
         * @param {String} patientId
         */
        removePatient(patientId) {
            this.$emit("remove-patient", patientId)
        }
    },

    computed: {
        ...mapState(["baseUrl"]),
        ...mapGetters('provider', ['getProvidersIdArray']),
        /**
         * List of patients that have 
         * active progress to print
         */
        activeSelectedPatients() {
            try {
                const today = new Date()
                const threeMonthsBefore = new Date().setMonth(today.getMonth() - 3)
                return this.selectedPatientList.filter(
                    ({ progress }) =>
                    progress && progress.total !== 0 && progress.completed !== 0
                )
            } catch (error) {
                console.error("Problem calculating activeSelectedPatients", error)
                return []
            }
        },
    },

    components: {
        MessageDialog
    }
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>